function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.47 83.82"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M87.19 70.51c-3.93-.09-6.36 2.48-6.44 6.68a6.61 6.61 0 0 0 6.63 6.59h.1c3.93.09 6.36-2.48 6.44-6.68-.02-3.61-2.16-6.39-6.73-6.59M88.31 0a23 23 0 0 0-10.89 2.4c-.71.49-1.51 1.58-1 2.29l.67 3.19c.28 1.9.77 2.6 2.78 1.72a18.3 18.3 0 0 1 6.37-1.33c5.59-.25 9.35 2.88 9.39 9.66s-3.19 11.13-6.85 17.88c-5.16 8.32-6.53 16.08-4.7 23.18.38 1.3.28 1.89 2.18 1.61l4.88.25c1.9-.28 1.41-1 1.62-2.18-1-8.18.52-13.45 4.07-19.6 4.25-6.64 9.1-13.17 8.89-22.44C105.4 8 100.69-.27 88.31 0",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-76.26 .04)"
  }));
};
export default SvgHelp;